import React, { createContext, useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import { prefix as userPrefix, adminPrefix } from '../../../routes/academy';
import { academyContext } from '../data/enums';

/**
 * @typedef AcademyRouteContextData
 * @property {academyContext} context - Current view context
 * @property {string} routePrefix - Current context routes prefix
 */

/**
 * @type {React.Context<AcademyRouteContextData>}
 */
export const AcademyContext = createContext({
  routePrefix: '/academy',
  context: academyContext.USER,
});

const AcademyContextProvider = props => {
  const location = useLocation();

  const [context, setContext] = useState(
    location.pathname.startsWith(adminPrefix) ? academyContext.ADMIN : academyContext.USER,
  );
  const [routePrefix, setRoutePrefix] = useState(location.pathname.startsWith(adminPrefix) ? adminPrefix : userPrefix);

  useEffect(() => {
    setContext(location.pathname.startsWith(adminPrefix) ? academyContext.ADMIN : academyContext.USER);
    setRoutePrefix(location.pathname.startsWith(adminPrefix) ? adminPrefix : userPrefix);

    return () => undefined;
  }, [location.pathname]);

  return <AcademyContext.Provider value={{ context, routePrefix }}>{props.children}</AcademyContext.Provider>;
};

export default AcademyContextProvider;
